var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-1 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2L12 2L12 0.375C12 0.167906 11.8321 0 11.625 0L11.375 0C11.1679 0 11 0.167906 11 0.375L11 2L5 2L5 0.375C5 0.167906 4.83209 0 4.625 0L4.375 0C4.16791 0 4 0.167906 4 0.375L4 2L2.5 2C1.67156 2 1 2.67156 1 3.5L1 14.5C1 15.3284 1.67156 16 2.5 16L13.5 16C14.3284 16 15 15.3284 15 14.5L15 3.5C15 2.67156 14.3284 2 13.5 2ZM2.5 3L13.5 3C13.7757 3 14 3.22431 14 3.5L14 5L2 5L2 3.5C2 3.22431 2.22431 3 2.5 3ZM13.5 15L2.5 15C2.22431 15 2 14.7757 2 14.5L2 6L14 6L14 14.5C14 14.7757 13.7757 15 13.5 15Z",
    id: "Icon-Color",
    fill: "current",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.cfaeada4e4236e304912154309a73fb2.svg";
export { ForwardRef as ReactComponent };